module.exports = __webpack_public_path__ + "static/media/metamask-warning.94c1b4de.jpg";